import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from '@contexts/AuthContext';
import { ProtectedRoute } from '@components/ProtectedRoute';
import { AppLayout } from '@components/layout/AppLayout';
import { Dashboard } from '@pages/Dashboard';
import { Login } from '@pages/Login';
import { BillsPage, BillCreatePage, VendorsPage, VendorCreatePage } from '@pages/accounts-payable';
import { InvoicesPage, InvoiceCreatePage, CustomersPage, CustomerCreatePage } from '@pages/accounts-receivable';
import { ProfilePage, SettingsPage, HelpPage, NotificationsPage } from '@pages/settings';
import { DesignPreview } from '@pages/DesignPreview';
import { ReportsPage } from '@pages/ReportsPage';
import BrazilianDemoPage from '@pages/BrazilianDemoPage';

function App() {
  const { isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-primary border-t-transparent" />
      </div>
    );
  }

  return (
    <Routes>
      {/* Public Routes */}
      <Route path="/login" element={<Login />} />
      <Route path="/design-preview" element={<DesignPreview />} />
      <Route path="/demo/brazil" element={<BrazilianDemoPage />} />

      {/* Protected Routes with Layout */}
      <Route
        element={
          <ProtectedRoute>
            <AppLayout />
          </ProtectedRoute>
        }
      >
        {/* Dashboard */}
        <Route path="/dashboard" element={<Dashboard />} />

        {/* Reports */}
        <Route path="/reports" element={<ReportsPage />} />

        {/* Accounts Payable */}
        <Route path="/accounts-payable/bills" element={<BillsPage />} />
        <Route path="/accounts-payable/bills/new" element={<BillCreatePage />} />
        <Route path="/accounts-payable/bills/create" element={<BillCreatePage />} />
        <Route path="/accounts-payable/vendors" element={<VendorsPage />} />
        <Route path="/accounts-payable/vendors/new" element={<VendorCreatePage />} />

        {/* Accounts Receivable */}
        <Route path="/accounts-receivable/invoices" element={<InvoicesPage />} />
        <Route path="/accounts-receivable/invoices/new" element={<InvoiceCreatePage />} />
        <Route path="/accounts-receivable/customers" element={<CustomersPage />} />
        <Route path="/accounts-receivable/customers/new" element={<CustomerCreatePage />} />

        {/* Settings & User */}
        <Route path="/profile" element={<ProfilePage />} />
        <Route path="/settings" element={<SettingsPage />} />
        <Route path="/help" element={<HelpPage />} />
        <Route path="/notifications" element={<NotificationsPage />} />
      </Route>

      {/* Redirects */}
      <Route path="/" element={<Navigate to="/dashboard" replace />} />
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

export default App;
